import {createSelector, ParametricSelector} from 'reselect';

import {TeammateAccountStatusesEnum} from '../../../models/api/teammateModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {AppState} from '../../appState';
import {getFindOnlineStatus} from '../teammates/onlineTeammatesSelectors';
import {getFlatTeammates} from '../teammates/teammatesSelectors';

/*
 * Constants.
 */

const inactiveTeammateStatuses = [TeammateAccountStatusesEnum.BLOCKED, TeammateAccountStatusesEnum.DELETED];

/*
 * Selectors.
 */

/** Compute teammate and onlineStatus for the specified visual contact. */
export const getFindTeammateAndOnlineStatusForVisualContact = createSelector(
  [getFlatTeammates, getFindOnlineStatus],
  (teammates, findOnlineStatus) => (visualContact: VisualContactModel) => {
    const teammate = teammates.find((t) => t.email === visualContact.contact.handle);
    if (!teammate || inactiveTeammateStatuses.includes(teammate.accountStatus)) {
      return visualContact;
    }

    const onlineStatus = findOnlineStatus(teammate);
    return {
      ...visualContact,
      teammate,
      onlineStatus,
    };
  },
);

type GetVisualContact = ParametricSelector<AppState, any, VisualContactModel>;
export function makeGetTeammateAndOnlineStatusForVisualContact(getVisualContact: GetVisualContact) {
  return createSelector(
    [getVisualContact, getFindTeammateAndOnlineStatusForVisualContact],
    (visualContact, findTeammateAndOnlineStatus) => findTeammateAndOnlineStatus(visualContact),
  );
}

export const getFindTeammateForVisualContact = createSelector(
  [getFlatTeammates],
  (teammates) => (visualContact: VisualContactModel) => {
    const teammate = teammates.find((t) => t.email === visualContact.contact.handle);
    if (!teammate || inactiveTeammateStatuses.includes(teammate.accountStatus)) {
      return visualContact;
    }

    return {
      ...visualContact,
      teammate,
    };
  },
);
